import { takeLatest, put, delay } from 'redux-saga/effects';
import * as TYPES from '../actions/types';
import { getClientDetailedInfo, loaderAction, saveAuthError, saveAuthResponse, saveClientDetailedInfo, saveForgotPasswordResponse, savechangePasswordResponse, setLinkedAccountList } from '../actions';
import { ChangePasswordResponse, ForgotPasswordResponse, GenericResponseModel } from '../../dataModel/authModels';
import { auth } from '../../services/authService';
import localKey from '../../storage/localKey';


export function* LoginSaga() {
  try {
    yield takeLatest(TYPES.LOGIN_ACTION, loginSagaAction);
  } catch (err) {
  }
}

function* loginSagaAction(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield auth.login(param['payload']);
    yield put(loaderAction(false));
    if (!response.status) {
      yield put(saveAuthError(response.message));
    } else {
      if (response.resultData.isTempPassword) {
        localStorage.setItem(localKey.TEMP_AUTH_TOKEN, response.resultData.token)
        yield put(saveAuthResponse(response.resultData));
      } else {
        yield put(getClientDetailedInfo())
        localStorage.setItem(localKey.AUTH_TOKEN, response.resultData.token)
        localStorage.setItem(localKey.IS_USER_PARENT, response.resultData.isParentAccount)
        yield put(saveAuthResponse(response.resultData));
      }
    }
  } catch (e) {

  }
}

export function* getLoginInfoSaga() {
  try {
    yield takeLatest(TYPES.GET_CLIENT_DETAIL_INFO, getInfoAction);
  } catch (err) {
  }
}

function* getInfoAction(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield auth.loginSession();
    yield put(loaderAction(false));
    if (response.status) {
      yield put(saveClientDetailedInfo(response.resultData));
    }
  } catch (e) {

  }
}

export function* getForgotPasswordSaga() {
  try {
    yield takeLatest(TYPES.FORGOT_PASSWORD, getForgotPasswordAction);
  } catch (err) {
  }
}

function* getForgotPasswordAction(param: any) {
  try {
    yield put(loaderAction(true));
    const response: ForgotPasswordResponse = yield auth.forgotPassword(param['payload']);
    yield put(loaderAction(false));
    if (response) {
      yield put(saveForgotPasswordResponse(response));
    }
  } catch (e) {

  }
}

export function* changePasswordSaga() {
  try {
    yield takeLatest(TYPES.CHANGE_PASSWORD, changePasswordAction);
  } catch (err) {
  }
}

function* changePasswordAction(param: any) {
  try {
    yield put(loaderAction(true));
    const response: ChangePasswordResponse = yield auth.changePassword(param['payload']);
    yield put(loaderAction(false));
    yield put(savechangePasswordResponse(response));
  } catch (e: any) {
  }
}

export function* getLinkedAccountSaga() {
  try {
    yield takeLatest(TYPES.GET_LINKED_ACCOUNT_LIST, accWorker);
  } catch (err) {
  }
}

function* accWorker(param: any) {
  try {
    yield put(loaderAction(true));
    const response: ChangePasswordResponse = yield auth.linkedAccounts();
    yield put(loaderAction(false));
    yield put(setLinkedAccountList(response));
  } catch (e: any) {
  }
}







